import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const fetchUserSystemSubscriptions = (): AxiosPromise<Array<CsdSystemSubscription>> => csttFacadeApi.get('/csttfacade/csdstatistics/v1/subscriptions');
const postUserSystemSubscriptions = (systemSubscriptions: Array<CsdSystemSubscription>): AxiosPromise => csttFacadeApi.post('/csttfacade/csdstatistics/v1/subscriptions', { systemSubscriptions});

export {
  fetchUserSystemSubscriptions,
  postUserSystemSubscriptions
}